import React, { ReactNode, useContext } from 'react';
import { Accordion, Card, AccordionContext, useAccordionToggle } from 'react-bootstrap';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//chevron-down
interface Props {
    children: ReactNode | string;
    eventKey: any;
    callback?: any;
}

function ContextAwareToggle({ children, eventKey, callback }: Props) {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = currentEventKey === eventKey;

    return (
        <button
            type="button"
            className={'d-flex p-2 w-100 justify-content-between align-items-center flex-row'}
            style={{ backgroundColor: isCurrentEventKey ? 'rgba(62, 129, 185, 0.3)' : 'rgba(0, 0, 0, 0.15)' }}
            onClick={decoratedOnClick}
        >
            {children}
        </button>
    );
}

interface PropsA {
    tabs: { eventKey: string; title: ReactNode | string; renderComponent: ReactNode | string }[];
    activeTab: string | number;
    setTab: (k: string | null) => void;
    additionalClass?: string;
}

const AccordionComponent: React.FC<PropsA> = ({ tabs, activeTab, setTab, additionalClass }: PropsA) => {
    return (
        <Accordion defaultActiveKey={`${activeTab ? activeTab : 0}`}>
            {tabs.map((it: any, k) => (
                <Card key={`cart-${k}`} className={additionalClass}>
                    <div
                        onClick={() => {
                            setTab(it.eventKey);
                        }}
                    >
                        <ContextAwareToggle eventKey={it.eventKey}>
                            <div>{it.title}</div>
                            <FontAwesomeIcon icon={faChevronDown} />
                        </ContextAwareToggle>
                    </div>
                    {activeTab === it.eventKey ? (
                        <Accordion.Collapse eventKey={`${it.eventKey}`}>
                            <Card.Body>{it.renderComponent()}</Card.Body>
                        </Accordion.Collapse>
                    ) : null}
                </Card>
            ))}
        </Accordion>
    );
};

AccordionComponent.defaultProps = {
    additionalClass: '',
};

export default AccordionComponent;
